const essentialUTMParams = [
    {
        urlParam: 'j',
        eventKey: 'job_id'
    },
    {
        urlParam: 'sfmc_sub',
        eventKey: 'subscriber_id'
    },
    {
        urlParam: 'l',
        eventKey: 'list'
    },
    {
        urlParam: 'u',
        eventKey: 'job_url_id'
    },
    {
        urlParam: 'mid',
        eventKey: 'member_id'
    },
    {
        urlParam: 'jb',
        eventKey: 'job_batch_id'
    },
    {
        urlParam: 'utm_source',
        eventKey: 'utm_source'
    },
    {
        urlParam: 'utm_medium',
        eventKey: 'utm_medium'
    },
    {
        urlParam: 'utm_campaign',
        eventKey: 'utm_campaign'
    },
    {
        urlParam: 'utm_sfmc',
        eventKey: 'utm_sfmc'
    },
    {
        urlParam: 'utm_term',
        eventKey: 'utm_term'
    }
];

function checkSomeUTMParamsContains(requiredKeys, availableKeys) {
    return (
        requiredKeys.some((element) => availableKeys.includes(element)) &&
    availableKeys.some((element) => requiredKeys.includes(element))
    );
}

function pushUTMParamsToDataLayer(url) {
    const isAllowedToPush = url.split('?').pop().includes('sfmc_sub'); // 'sfmc_sub' is a medatory parameter to pushing the data
    if(!isAllowedToPush) return;
    const dataLayer = window.dataLayer || [];
    const urlParamKeys = essentialUTMParams.map(({ urlParam }) => urlParam);

    const eventData = url
        .split('?')
        .pop() // pop out main url and remains only query params, previously we splitting with & which filtering out first element is less efficient and also it removes first query params with main url which can lead to potential bugs if they contain any SFMC parameters
        .split('&')
        .map((e) => {
            const [key, value] = e.split('=');
            if(urlParamKeys.includes(key)) {
                const newKey = essentialUTMParams.find((e) => e.urlParam === key);
                return { [newKey.eventKey]: value };
            }
        })
        .filter(Boolean) // To filter out any params which also included in url but we dont need to push
        .reduce((pre, cur) => {
            // to convert the array into object of event keys
            const key = Object.keys(cur)[0];
            const value = cur[key];
            pre[key] = value;
            return pre;
        }, {});
    const requiredEventKeys = essentialUTMParams.map(
        ({ eventKey }) => eventKey
    );
    const availableEventKeys = Object.keys(eventData);
    const isMatch = checkSomeUTMParamsContains(
        requiredEventKeys,
        availableEventKeys
    );
    if(!isMatch) return;
    dataLayer.push({
        event: 'SF_UTM_Tracking',
        ...eventData
    });
    console.log('SF_UTM_Tracking push successfully', dataLayer);
}

$(function () {
    const url = window.location.href;
    pushUTMParamsToDataLayer(url);
});
